export class ErrorState {
    invalid: boolean = false;
    errorMessage: string = '';
}

export class ScheduleFormState {
    submitted: boolean = false;
    loc: ErrorState = new ErrorState();
    scheduleBeginDate = new ErrorState();
    scheduleEndDate = new ErrorState();
    commodity = new ErrorState();
    location = new ErrorState();

    isValid(): boolean {
        return !this.loc.invalid
            && !this.scheduleBeginDate.invalid
            && !this.scheduleEndDate.invalid
            && !this.commodity.invalid
            && !this.location.invalid;
    }
}

export class DispatchFormState {
    submitted: boolean = false;
    beginDate: ErrorState = new ErrorState();
    endDate: ErrorState = new ErrorState();
    location: ErrorState = new ErrorState();
    loads: ErrorState = new ErrorState();
    rate: ErrorState = new ErrorState();
    rateUnitOfMeasure: ErrorState = new ErrorState();

    isValid(): boolean {
        return !this.beginDate.invalid
            && !this.endDate.invalid
            && !this.location.invalid
            && !this.loads.invalid
            && !this.rate.invalid
            && !this.rateUnitOfMeasure.invalid;
    }
}

export class SendDispatchFormState {
    submitted: boolean = false;
    truckerContact: ErrorState = new ErrorState();
    scoularContact: ErrorState = new ErrorState();
    sendOptions: ErrorState = new ErrorState();
    dispatch: ErrorState = new ErrorState();
    truckerPhone: ErrorState = new ErrorState();

    isValid(): boolean {
        return !this.truckerContact.invalid
            && !this.scoularContact.invalid
            && !this.sendOptions.invalid
            && !this.dispatch.invalid
            && !this.truckerPhone.invalid 
    }
}

export class LocationConfirmFormState {
    locationSubmitted: boolean = false;
    internalSubmitted: boolean = false;
    location: ErrorState = new ErrorState();
    locationEmail: ErrorState = new ErrorState();
    internalEmail: ErrorState = new ErrorState();

    isValid(): boolean {
        return !this.location.invalid
            && !this.locationEmail.invalid
            && !this.internalEmail.invalid;
    }
}

export class RoundFormState {
    submitted: boolean = false;
    trucker: ErrorState = new ErrorState();
    dispatchCount: ErrorState = new ErrorState();
    dispatchTrucker: ErrorState = new ErrorState();
    periodDates: ErrorState = new ErrorState();

    isValid(): boolean {
        return !this.trucker.invalid
            && !this.dispatchCount.invalid
            && !this.periodDates.invalid;
    }
}

export interface ContactInfoFormState {
    submitted: boolean,
    name: ErrorState,
    phone: ErrorState,
    fax: ErrorState,
}